const SystemListEvent = {
  CHANGED: 'systemListChanged',
  FILTER_CHANGED: 'systemListFilterChanged',
  SYSTEM_DESELECTED: 'systemListSystemDeselected',
  SYSTEM_SELECTED: 'systemListSystemSelected',
  SHOW_UNLICENSED_SYSTEMS_TOGGLED: 'systemListShowUnlicensedSystemsToggled',
};

export default SystemListEvent;
